import { render, staticRenderFns } from "./ItemRefundCollectionForm.vue?vue&type=template&id=874878ea&scoped=true&"
import script from "./ItemRefundCollectionForm.vue?vue&type=script&lang=js&"
export * from "./ItemRefundCollectionForm.vue?vue&type=script&lang=js&"
import style0 from "./ItemRefundCollectionForm.vue?vue&type=style&index=0&id=874878ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874878ea",
  null
  
)

export default component.exports